import { useEffect, useMemo } from 'react';
import { UseFormReturn } from 'react-hook-form';
import { Question, State } from 'src/@types/generalEnquete';
import RHFDeskTopDatePicker from 'src/components/react-hook-form/RHFDeskTopDatePicker';
import { useEnqueteAnswerValidator } from 'src/features/general/enquete-answer/components/tab-containers/type-general-question/components/tabs/question-and-answer/hooks/useEnqueteAnswerValidator';
import { dateFormat } from 'src/utils/formatDateTime';
//useEnqueteAnswerHandleOnChangeをインポートする
import { useEnqueteAnswerHandleOnChange } from '../hooks/useEnqueteAnswerHandleOnChange';

type EnqueteAnswerDateFormProps = {
  question: Question;
  index: number;
  methods: UseFormReturn;
  languageCode?: string;
  questionState?: State;
  //ルールチェックしないフラグ
  noCheckRule?: boolean
};

const EnqueteAnswerDateForm = ({ question, index, methods, languageCode, questionState, noCheckRule }: EnqueteAnswerDateFormProps) => {
  const { rulesEnqueteAnswerDate } = useEnqueteAnswerValidator(methods as UseFormReturn, question, languageCode, questionState);
  const memolizedRuleDate = useMemo(() => rulesEnqueteAnswerDate, [rulesEnqueteAnswerDate]);
  //handleOnChangeDateを取得する
  const { handleOnChangeDate } = useEnqueteAnswerHandleOnChange();
  // 質問表示状態が変ったらルールをスイッチする。
  useEffect(() => {
    if (methods && question.answerItem) {
      if (methods?.getValues(question.questionItem[0].id) !== undefined) {
        const stateRule = questionState === 'disabled' || questionState === 'hidden' || noCheckRule ? {} : memolizedRuleDate;
        const value = methods?.getValues(question.questionItem[0].id) ?? '';
        methods?.control.unregister(question.questionItem[0].id);
        methods?.control.register(question.questionItem[0].id, stateRule);
        methods?.setValue(question.questionItem[0].id, value);
        methods?.trigger(question.questionItem[0].id);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questionState]);

  return (
    <RHFDeskTopDatePicker
      control={methods?.control}
      name={question.questionItem[0].id}
      rules={questionState === 'disabled' || questionState === 'hidden' || noCheckRule  ? {} : memolizedRuleDate}
      mask={'____/__/__'}
      defaultValue={question.answerItem !== undefined && question.answerItem[0]?.value ? new Date(String(question.answerItem[0].value)) : null}
      inputFormat={dateFormat}
      sx={{ width: 190 }}
      //日付変更時の変更イベント
      onChange={(e) => {
        handleOnChangeDate(e, question, index, 0);
      }}
      //日付キーボード入力変更時の変更イベント
      onInput={(e) => {
        handleOnChangeDate(e, question, index, 0);
      }}
      disabled={questionState === 'disabled'}
    />
  );
};
export default EnqueteAnswerDateForm;
